var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsTableTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#17A1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5C5.72386 12.5 5.5 12.2761 5.5 12C5.5 11.7239 5.72386 11.5 6 11.5V12.5ZM18.3521 11.6464C18.5474 11.8417 18.5474 12.1583 18.3521 12.3536L15.1701 15.5355C14.9749 15.7308 14.6583 15.7308 14.463 15.5355C14.2678 15.3403 14.2678 15.0237 14.463 14.8284L17.2914 12L14.463 9.17157C14.2678 8.97631 14.2678 8.65973 14.463 8.46447C14.6583 8.2692 14.9749 8.2692 15.1701 8.46447L18.3521 11.6464ZM6 11.5L17.9985 11.5V12.5L6 12.5V11.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsTableTransfer);
export default __webpack_public_path__ + "static/media/products-table-transfer.8b28828743fd3af0d2999f9b5c4caec7.svg";
export { ForwardRef as ReactComponent };